// extracted by mini-css-extract-plugin
module.exports = {"container":"AsideMedia_container__FqW1U","media":"AsideMedia_media__zSZR9"};